import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f6b8c9f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "pro_list"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "recommended"
};
const _hoisted_4 = {
  class: "image"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "projectItemUserInfo"
};
const _hoisted_7 = {
  class: "icon"
};
const _hoisted_8 = ["src", "fit"];
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "rank_title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/rank/detail_rank_icon.png"
}, null, -1));
const _hoisted_13 = {
  key: 1,
  class: "tag"
};
const _hoisted_14 = {
  key: 2,
  class: "tag"
};
const _hoisted_15 = {
  class: "projectItemTitle"
};
const _hoisted_16 = {
  class: "projectItemStatus"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 0,
  class: "backer_money ing"
};
const _hoisted_22 = {
  key: 1,
  class: "backer_count ing"
};
const _hoisted_23 = {
  class: "percent ing"
};
import Error from "@@/common/Error.vue";
import MDRouter from "@/service/router";
import navLoading from '@@/rank/loading.vue';
import { List, showFailToast } from 'vant';
import { mdProjectList } from "@api/index";
import { ref, watch, onMounted, reactive } from 'vue';
export default {
  setup(__props, {
    expose
  }) {
    const state = reactive({
      refreshing: false,
      loading: true,
      finished: false,
      fit: 'cover',
      list: [],
      page: 1,
      postCount: 0,
      repoint: false,
      default_logo: 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png',
      default_img: 'https://s.moimg.net/m/img/placeholder/default_21x9@2x.png'
    });
    const category = ref('all');
    const status = ref('0');
    const rank = ref('time');
    const repoint = ref(false);
    expose({
      category,
      status,
      rank,
      repoint
    });
    watch(() => repoint.value, () => {
      console.log('watch:' + repoint.value);
      console.log(category.value);
      if (repoint.value) {
        state.finished = false;
        state.page = 1;
        state.postCount = 0;
        getList();
      }
    });
    onMounted(() => {
      //document.getElementById('app').style.height = '100%';
      resetHeight(["#app", ".cont-warp"]);
    });
    const show_category = item => {
      let result = false;
      if (item.category) {
        result = true;
        if (item.rank_info && item.rank_info.rank_tag_name && !item.rank_info.is_total_rank) {
          result = false;
        }
      }
      return result;
    };
    // 翻页
    const onLoad = () => {
      if (state.refreshing) {
        state.list = [];
        state.page = 1;
        state.postCount = 0;
        state.refreshing = false;
      }
      getList();
    };
    // 下拉刷新
    // const onRefresh = () => {
    //     state.finished = false;
    //     // 将 loading 设置为 true，表示处于加载状态
    //     state.loading = true;
    //     onLoad();
    // };
    const getList = () => {
      state.postCount++;
      if (state.page == 1 && state.postCount > 1) {
        return false;
      }
      state.loading = true;
      let option = {
        //分类
        category: localStorage.getItem("list_category") || category.value,
        //状态
        status: status.value,
        //排序
        rank: rank.value,
        //项目列表
        type: 2,
        page_size: 10,
        page: state.page,
        request_id: ''
      };
      mdProjectList(option).then(res => {
        if (res.status == 0) {
          if (state.page == 1) {
            state.list.splice(0, state.list.length);
          }
          if (res.data.list && res.data.list.length > 0) {
            state.list.push(...res.data.list);
            state.page++;
          }
          // 加载状态结束
          state.loading = false;
          repoint.value = false;

          // 数据全部加载完成
          if (!res.data.is_next || res.data.list.length == 0) {
            state.finished = true;
          }
        } else {
          showFailToast(res.message);
        }
      });
    };
    getList();
    // 去详情
    const goToInfo = id => {
      MDRouter.goProInfo(id);
    };
    // 去排行榜
    const goCategoryList = item => {
      window.location.href = item.h5_link;
    };
    const resetHeight = elmArr => {
      elmArr.forEach(item => {
        var type = item.slice(0, 1),
          elm = item.slice(1);
        switch (type) {
          case '#':
            document.getElementById(elm).style.height = '100%';
            break;
          case '.':
            document.getElementsByClassName(elm)[0].style.height = '100%';
            break;
          default:
            document.getElementsByTagName(item)[0].style.height = '100%';
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(List), {
        loading: _unref(state).loading,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _unref(state).loading = $event),
        finished: _unref(state).finished,
        "immediate-check": false,
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_unref(state).list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            onClick: $event => goToInfo(item.id)
          }, [item.recommended == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            src: _ctx.$imgUrlFilter(item.logo7x3, 690, 296) || _unref(state).default_img,
            onerror: "javascript:this.src='https://s.moimg.net/m/img/placeholder/default_21x9@2x.png'"
          }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
            src: _ctx.$imgUrlFilter(item.user_info.icon, 38, 38) || _unref(state).default_logo,
            fit: _unref(state).fit,
            onerror: "javascript:this.src='https://s.moimg.net/m/img/placeholder/default_1x1@2x.png'"
          }, null, 8, _hoisted_8)]), _createElementVNode("p", _hoisted_9, _toDisplayString(item.user_info.username), 1), item.rank_info && item.rank_info.rank_tag_name ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "rank_info",
            onClick: _withModifiers($event => goCategoryList(item.rank_info), ["stop"])
          }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" " + _toDisplayString(item.rank_info.rank_tag_name), 1)])], 8, _hoisted_10)) : _createCommentVNode("", true), category.value == 'all' && show_category(item) ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(item.category), 1)) : _createCommentVNode("", true), status.value == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.status_zh), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, _toDisplayString(item.short_title), 1), _createElementVNode("div", _hoisted_16, [item.status_code == '1' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [item.subscribe_count ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(item.subscribe_count) + "人看好", 1)) : _createCommentVNode("", true), item.start_time ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(item.start_time) + "开始", 1)) : _createCommentVNode("", true)], 64)) : item.status_code == '4' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [item.bullish_count ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(item.bullish_count) + "人看好", 1)) : _createCommentVNode("", true), item.comment_num ? (_openBlock(), _createElementBlock("p", _hoisted_20, "评论 " + _toDisplayString(item.comment_num), 1)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [item.backer_money ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(item.backer_money), 1)) : _createCommentVNode("", true), item.backer_count ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(item.backer_count), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_23, _toDisplayString(item.percent) + "%", 1)], 64))])], 8, _hoisted_2);
        }), 128))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["loading", "finished"]), !_unref(state).loading && _unref(state).list.length == 0 && _unref(state).loading == false ? (_openBlock(), _createBlock(Error, {
        key: 0,
        message: "什么都没有哦",
        class: "empty-box"
      })) : _createCommentVNode("", true), _unref(state).loading && _unref(state).page == 1 ? (_openBlock(), _createBlock(navLoading, {
        key: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
};